import { find } from 'lodash';
import { Injectable } from '@angular/core';
import { ColumnaMaestra, OptionsColumns, TablaMaestra } from '@app/shared';

@Injectable()
export class CreationFormUtilsService {

  // Lista de tablas maestraas
  masterTables: TablaMaestra[] = [];
  // Lista de consultas personalizadas
  customSerach: any[] = [];

  constructor() { }

  /**
   * Carga la informacion de las columnas de la maestra seleccionada para mostrarla en el ngSelect
   *
   * @param {ColumnaMaestra[]} structure
   * @param {number} idmaster
   * @param {boolean} [idestruture=false]
   * @param {boolean} [replaceTypeField=true]
   * @returns {Array<OptionsColumns>}
   * @memberof CreationFormUtilsService
   */
  loadingColumnsViews(
    structure: ColumnaMaestra[],
    idmaster: number,
    idestruture: boolean = false,
    replaceTypeField: boolean= true
  ): Array<OptionsColumns> {

    const mastersC: Array<OptionsColumns> = [];
    const masterName = find(this.masterTables, {id: Number(idmaster)}).nombre;

    structure.forEach(async etr => {
      if (etr.tipo_campo['nombre'] === 'ngSelect') {
        if (etr.maestra_dependencia['estructura']) {
          // tslint:disable-next-line:max-line-length
          const otherMaster: Array<OptionsColumns> = this.loadingColumnsViews(etr.maestra_dependencia['estructura'], etr.maestra_dependencia['id'], idestruture, replaceTypeField);
          otherMaster.forEach(el => {
            const column: OptionsColumns = {
              key: el.key,
              value: etr.id + '_' + el.value,
              masterDependencia: el.masterDependencia,
              column: etr.nombre,
              type: replaceTypeField ?
                      (typeof etr.tipo_campo === 'number') ?
                        String(etr.tipo_campo)
                      : etr.tipo_campo.nombre
                    : el.type
            };
            if (column.type === 'date-time-picker') {
              column.category = etr.propiedades['tipo'];
            }
            mastersC.push(column);
          });
        }
        if (idestruture) {
          const column: OptionsColumns = {
            key: etr.nombre,
            value: String(etr.id),
            masterDependencia: masterName,
            column: etr.nombre,
            type: (typeof etr.tipo_campo === 'number') ? String(etr.tipo_campo) : etr.tipo_campo.nombre
          };
          if (column.type === 'date-time-picker') {
            column.category = etr.propiedades['tipo'];
          }
          mastersC.push(column);
        }
      } else {
        const column: OptionsColumns = {
          key: etr.nombre,
          value: String(etr.id),
          masterDependencia: masterName,
          column: etr.nombre,
          type: (typeof etr.tipo_campo === 'number') ? String(etr.tipo_campo) : etr.tipo_campo.nombre
        };
        if (column.type === 'date-time-picker') {
          column.category = etr.propiedades['tipo'];
        }
        mastersC.push(column);
      }
    });

    return mastersC;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/shared/creation-form.utils.sevice.ts